<div class="flex-column-center-center">
    <app-last-transactions></app-last-transactions>
    <p>{{'last_10d_operations' | translate}}</p>
</div>
